import React from 'react';

const AuthorBio = (postData) => {


  const blogData = postData.postData || {};

  return (
    <div class="profile-img">
      <img src={blogData.addedbyphoto} alt={blogData.authorname || "Author"} width={160} height={160} />

      <h3>{blogData.authorname}</h3>
      <p>{blogData.authorbio}</p>

      {/* <ul class="social-icon">
                                        <li class="share">
                                            Share
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-facebook"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-twitter"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-linkedin"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-youtube"></i>
                                            </a>
                                        </li>
                                    </ul> */}
    </div>
  );
};

export default AuthorBio;